import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import callApi from '../../helpers/callapi'
import { Form, Card, Button, Row, Col } from 'react-bootstrap'
import config from '../../config'

export default function TransferSlip() {
  const dispatch = useDispatch()

  const [qrText, setQrText] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [slip, setSlip] = useState({ refNo: null, evidence: null })
  const [fullSlip, setFullSlip] = useState(false)

  const fetchSlip = async () => {
    try {
      setQrText('')
      setIsLoading(true)
      const response = await callApi({ url: `/orders/bad-qr/${slip.refNo || null}?oredersBy=asc` })
      if (response.status === 'success') {
        if (response.refNo && response.evidence) {
          setSlip(response)
        } else {
          setSlip({ refNo: null, evidence: null })
          setErrorMessage(response.message)
        }
      } else {
        setSlip({ refNo: null, evidence: null })
      }
    } catch (err) {
      console.log(err)
      setSlip({ refNo: null, evidence: null })
      setErrorMessage(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchSlip()
  }, [orderBy])

  const updateOrder = async (qrText, orderRefNo) => {
    let fullURL = `${config.urlHost}/transferRef/check`
    if (['can not scan', 'not slip'].includes(qrText)) fullURL = `${config.apiHost}/orders/badQrReason`
    callApi({
      fullURL,
      method: 'post',
      body: { qrText, orderRefNo: orderRefNo },
    })
    setFullSlip(false)
    fetchSlip()
  }

  // if (!isLoading) return dispatch(showLoading());

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Scaning</Card.Title>
        </Card.Header>
        <Card.Body>
          <h4 style={{ textAlign: 'center', marginBottom: '30px' }}>
            Bank Slip Scan {orderBy === 'asc' ? '' : 'Reverse'}
          </h4>
          <div className="d-flex justify-content-center">{errorMessage && <h4>{errorMessage}</h4>}</div>
          {!errorMessage && (
            <Row className="d-flex h-100" style={{ textAlign: 'center', minHeight: '740px' }}>
              <Col sm={12} md={4}>
                <div className="d-flex justify-content-center bg-danger rounded p-4 h-100">
                  <div>
                    <Form.Group>
                      <Form.Label className="text-white h1">ไม่ใช่สลิป</Form.Label>
                    </Form.Group>
                    <img src={'/img/notslip.jpg'} style={{ maxHeight: 150, width: 'auto' }} alt="" />
                  </div>
                  <div className="position-absolute" style={{ bottom: '0px' }}>
                    <img src="/img/notslip.png" alt="rilakkuma" />
                  </div>
                </div>
              </Col>
              <Col sm={12} md={4}>
                <Form.Group>
                  {/* <Form.Label>แสดงแถวละ</Form.Label> */}
                  <div>
                    <Form.Control
                      id="qrcode"
                      type="text"
                      placeholder="ยิงบาร์โค้ดที่นี่"
                      value={qrText}
                      onChange={(e) => setQrText(e.target.value)}
                      onKeyDown={({ key }) => {
                        if (key === 'Enter') updateOrder(qrText, slip.refNo)
                      }}
                      autoFocus
                    />
                  </div>
                  <div className="d-flex pt-3">
                    <Button className="w-50 btn btn-danger mr-3" onClick={() => updateOrder('not slip', slip.refNo)}>
                      ไม่ใช่สลิป
                    </Button>
                    <Button
                      className="w-50 btn btn-success ml-3"
                      onClick={() => updateOrder('can not scan', slip.refNo)}
                    >
                      สลิปสแกนไม่ได้
                    </Button>
                  </div>
                </Form.Group>
                <div className="d-flex justify-content-center w-100 bg-light rounded" style={{ minHeight: '600px' }}>
                  {slip.evidence ? (
                    <img
                      src={slip.evidence}
                      style={{
                        marginTop: '10px',
                        width: 'auto',
                        maxHeight: `${(40 / 100) * window.innerHeight}px`,
                        cursor: 'pointer',
                      }}
                      alt=""
                      onClick={() => {
                        document.querySelector('#qrcode').focus()
                        setFullSlip(true)
                      }}
                    />
                  ) : (
                    <div style={{ marginTop: 10 }}>No Image Available</div>
                  )}
                </div>
              </Col>
              <Col sm={12} md={4}>
                <div className="d-flex position-relative justify-content-center bg-success rounded p-4 h-100">
                  <div>
                    <Form.Group>
                      <Form.Label className="h1 text-white">สแกนไม่ได้</Form.Label>
                    </Form.Group>
                    <img src={'/img/unscannable.jpg'} style={{ maxHeight: 150, width: 'auto' }} alt="" />
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {fullSlip === true && (
            <div style={{ textAlign: 'center' }}>
              {slip.evidence && (
                <img
                  src={slip.evidence}
                  style={{ marginTop: '20px', maxHeight: `${(70 / 100) * window.innerHeight}px` }}
                />
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </Fragment>
  )
}
